import axios from 'axios';

export default function getStateCountry(config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const url = config.stateCountyCodes;
  return dispatch => dispatch({
    type: 'STATE_COUNTRY_FETCH',
    payload: axios({ method: 'get', url, headers })
  })
}


// WEBPACK FOOTER //
// ./src/actions/getStateCountry.js